/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { computed, observable } from 'mobx';
import { IEveLocaleSwitcherData } from './eve-locale-switcher.data';
import { IChannelConfigData, IEveLocaleSwitcherProps } from './eve-locale-switcher.props.autogenerated';
import { GridSize } from '../../themes/mirageworks/views/header.view';
import { Button } from 'reactstrap';

export interface IEveLocaleSwitcherViewProps extends IEveLocaleSwitcherProps<IEveLocaleSwitcherData> {
    state: IEveLocaleSwitcherState;
    showModal: boolean;
    modalDisplay: JSX.Element;
}

export interface IEveLocaleSwitcherState {
    isMobile: boolean;
}

/**
 *
 * EveLocaleSwitcher component
 * @extends {React.PureComponent<IEveLocaleSwitcherProps<IEveLocaleSwitcherData>>}
 */
class EveLocaleSwitcher extends React.PureComponent<IEveLocaleSwitcherProps<IEveLocaleSwitcherData>, IEveLocaleSwitcherState> {
    @observable
    private viewport: GridSize;
    constructor(props: IEveLocaleSwitcherViewProps) {
        super(props);
        this.viewport =
            props.context.request && props.context.request.device && props.context.request.device.Type === 'Mobile' ? 'xs' : 'lg';
        this.state = {
            isMobile: this.isMobile
        };
    }

    @computed get isMobile(): boolean {
        return this.viewport === 'xs' || this.viewport === 'sm';
    }

    public shouldShowModal(): boolean {
        if (
            this.props.app.config.enableUserRoles &&
            //this.props.context.request.user.isAuthenticated &&
            this.props.context.request.cookies.isConsentGiven() &&
            //@ts-ignore ITS REAL I PROMISE
            this.props.context.request.User &&
            this.props.context.request.user.isAuthenticated
        ) {
            if (
                //@ts-ignore
                this.props.context.request.channel.RecordId &&
                //@ts-ignore
                this.props.context.request.User.ChannelId !== this.props.context.request.channel.RecordId.toString()
            ) {
                //Customer is on the wrong channel, show the modal please!
                return true;
            }
        }
        return false;
    }

    public displayModal(): JSX.Element {
        const localeButtons: IChannelConfigData[] = [];
        //@ts-ignore I NEED THIS PLEASE IM SORRY
        const userChannel = `${this.props.context.request.User.ChannelId}`;
        this.props.config.channels?.forEach(item => {
            if (item.ChannelId === userChannel) {
                localeButtons.push(item);
            }
        });
        return (
            <div className='eve-locale-switcher__modal'>
                <div className='eve-locale-switcher__wrapper'>
                    <div className='eve-locale-switcher__title-section'>
                        <h2 className='eve-locale-switcher__title'>{this.props.resources.modalTitle}</h2>
                    </div>
                    <div className='eve-locale-switcher__description-section'>
                        <h4 className='eve-locale-switcher__description'>{this.props.resources.explanation}</h4>
                    </div>
                    <div className='eve-locale-switcher__channel-row'>
                        {localeButtons.map((item, index) => (
                            <Button key={index} className='eve-locale-switcher__button' href={item.ChannelUrl}>
                                {item.ChannelName}
                            </Button>
                        ))}
                    </div>
                    <div className='eve-locale-switcher__channel-row-logout'>
                        <Button className='eve-locale-switcher__button-logout' href={this.props.context.request.user.signOutUrl}>
                            {this.props.resources.logoutButton}
                        </Button>
                    </div>
                </div>
            </div>
        );
    }

    public render(): JSX.Element | null {
        const viewProps: IEveLocaleSwitcherViewProps = {
            ...this.props,
            state: this.state,
            showModal: this.shouldShowModal(),
            modalDisplay: this.displayModal()
        };

        return this.props.renderView(viewProps);
    }
}

export default EveLocaleSwitcher;
